import "./_style.scss";

let uid = 0;

export default {
  inject: {
    elFormItem: {
      default: "",
    },
    handleChange: {
      default: () => {}
    }
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    isInputBlur: {
      type: Boolean,
      default: false,
    },
    isZero: {
      type: Boolean,
      default: false
    },
    showInputFocusStyle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: `label-input-${uid++}`,
      active: this.isValidValue(),
      visibleChange:false,
      prevValue: []
    };
  },
  computed: {
    isRequired() {
      if (this.elFormItem) {
        return this.elFormItem.isRequired;
      }
      return false;
    },
  },
  watch: {
    value() {
      this.handleChange && this.handleChange(this.id, this.value)
      if (this.isValidValue()) {
        this.active = true;
      }
      else {
        this.active = false;
      }
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    renderInput(createElement, vNodeData) {
      throw Error("Please implement a input VNode.");
    },
    multipleSelectCheckboxsFn() {
      let multipleSelectCheckboxs = document.querySelectorAll(".multiple_select_checkbox");
      multipleSelectCheckboxs.forEach((item)=>{
      if(item.children[1].children[2]) {
        item.children[1].children[2].style.display = "none"
      }
      })
    },
    isValidValue() {
      if(this.visibleChange) return true;
      if (this.value && Array.isArray(this.value)) {
        return this.value.length !== 0;
      }
      if (this.value === 0) {
        return true
      }
      return Boolean(this.value);
    },
  },
  render(h) {
    return h("div", { class: {
      "label-input2": true,
      "is-disabled": this.disabled,
      "label_input2_label_focus_style": this.showInputFocusStyle
    } }, [
      h(
        "label",
        {
          attrs: { for: this.id },
          class: {
            "label-input2__label": true,
            "label-input2__label--active": this.active || this.showInputFocusStyle,
            "label-input2__label--required": this.isRequired,
          },
        },
        this.label
      ),
      this.renderInput(h, {
        props: { value: this.value },
        class: this.id,
        attrs: {
          id: this.id,
          ...this.$attrs,
          disabled: this.disabled,
          placeholder: this.active || !this.label ? this.$attrs.placeholder : this.isInputBlur ? this.$attrs.placeholder : '',
        },
        
        on: {
          ...this.$listeners,
          'visible-change': (data) => {
            this.active = data;
            try{
              data ?  this.$el.children[0].style = 'color:#4066d4' : this.$el.children[0].style = 'color:#7f8596'
            } catch {
              //  eslint-disable-next-line
            }
            this.visibleChange = data;
            if(!data) {
              this.active = this.isValidValue();
            }
            if(data) {
              setTimeout(() => {
                this.multipleSelectCheckboxsFn()
              })
            }
            this.$emit('visible-change', data);
          },
          focus: () => {
            setTimeout(() => {
              this.multipleSelectCheckboxsFn()
            })
            document.querySelectorAll('.popper__arrow').forEach(item => item.stlye = 'display: none')
            this.active = true;
            try {
              this.$el.children[0].style = 'color:#4066d4'
              if(this.value === undefined) {
                this.$el.children[1].children[2].style = `display: none`
              }
            } catch {
               //  eslint-disable-next-line
            }
            this.$emit("focus");
            
          },
          blur: () => {
            console.log('444-flase');
            this.$el.children[0].style = 'color:#7f8596;font-weight: 500;'
            try {
              if(this.value === undefined) {
                this.$el.children[1].children[2].style = `display: none`
              }else {
                this.$el.children[1].children[2].style = `display: block;`
                this.$el.children[0].style = 'color:#7f8596'
              }
            } catch  {
              //  eslint-disable-next-line
            }
            try {
              if (
                (!this.value !== "" &&
                  this.value !== undefined &&
                  this.value !== null && this.value.length !== 0) ||
                this.value == undefined
              ) {
                this.$el.children[0].style = 'color:#7f8596'
                this.value = this.value.trim()
              }
            } catch {
              //  eslint-disable-next-line
            }
            this.active = this.isValidValue();
            this.$emit("blur",this.value);
          },
          change: (value) => {
            if (typeof value === 'string') {
              this.$emit("input", value.trim())
            }
            this.$emit("change", value);
          },
        },
      }),
      this.$slots.suffix
        ? h("div", { class: "label-input__suffix" }, this.$slots.suffix)
        : null,
    ]);
  },
  mounted() {
    console.log('this.$slots', this.$slots, this)
    this.handleChange && this.handleChange(this.id, this.value);
    [...document.querySelectorAll('.label-input2__label ')].forEach((item) => {
      item.style = 'color:#7f8596;'
    })
  }
};
